import React, { useState } from "react";
import PdfPreview from "../Modal/PdfPreview";

interface ReportsCardProps {
  item: any;
  index: number;
  color: string;
  type :"reports" | "documents"
}

const ReportsCard = ({ item, index, color, type }: ReportsCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formattedIndex = index < 9 ? `0${index + 1}` : `${index + 1}`;

  const handleCardClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <div
        className="takaful--reports-card-container"
        onClick={handleCardClick}
      >
        <div
          className={`takaful--reports-card-index ${
            color === "gray"
              ? "takaful--gray-color-index"
              : "takaful--blue-color-index"
          }`}
        >
          <span>{formattedIndex}</span>
        </div>
        <div
          dir="rtl"
          className={`takaful--reports-card-name ${
            color === "gray"
              ? "takaful--gray-color-name"
              : "takaful--blue-color-name"
          }`}
        >
          <span className="takaful--reports-card-name-span">{item?.name}</span>
        </div>
      </div>
      {/* Preview */}
      <PdfPreview
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        url={type ==="reports" ? item?.attachment_ids : item?.url}
        className="takaful--pdf-preview-modal"
      />
    </>
  );
};

export default ReportsCard;
